export default __webpack_public_path__ + "static/jackPotParticipar-d45c3e769cca79a1decb8da731c04e6e.png";